import { render, staticRenderFns } from "./html.vue?vue&type=template&id=215c7b94&"
import script from "./html.vue?vue&type=script&lang=js&"
export * from "./html.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports